export enum DICTIONARY {
  BLOQUEO_CREDITO = "Bloqueado de crédito",
  SIN_BLOQUEO_CREDITO = "Sin bloqueo",
  BLOQUEO_ENTREGA = "Bloqueo Entrega",
  BLOQUEO_FACTURA = "Bloqueo Factura",
}
